import React, { useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosInstance';

const IncomeWidget = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axiosInstance.get('/journal/income-summary')
      .then(res => {
        if (res.data.success) setData(res.data.data);
      })
      .catch(err => {
        console.error('Failed to load income summary', err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-white shadow rounded-md p-4 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-20 mb-3"></div>
            <div className="h-8 bg-gray-200 rounded w-28"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-center">
        <p className="text-red-600 text-sm">Failed to load income data</p>
        <button
          onClick={() => { setError(false); setLoading(true); }}
          className="mt-2 text-sm text-red-700 underline hover:no-underline"
        >
          Retry
        </button>
      </div>
    );
  }

  const cards = [
    { label: 'Today', value: data.today },
    { label: 'This Week', value: data.thisWeek },
    { label: 'Last Week', value: data.lastWeek },
    { label: 'This Month', value: data.thisMonth },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className="bg-white shadow-lg rounded-md p-4 flex flex-col justify-between transition-transform hover:scale-105"
        >
          <h4 className="text-gray-600 text-sm uppercase">{card.label}</h4>
          <p className="text-2xl font-bold text-green-600">
            ${(card.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
        </div>
      ))}
    </div>
  );
};

export default IncomeWidget;
